<template>
  <section class="invoice-add-wrapper">
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-form
        @submit.prevent="handleSubmit(addUpdateItemAction)"
        @reset.prevent="resetForm"
        v-if="analyticplanData != null"
      >
        <b-row style="margin-bottom: 20px">
          <b-col cols="6">
            <h6
              class="section-label text-primary float-left"
              style="
                border-right: 5px solid orange;
                border-bottom: 1px solid orange;
                border-radius: 0px 50px 0px 0px;
                font-size: 18px;
                padding-right: 10px;
                top: 1px;
                width: auto;
              "
            >
              <feather-icon icon="FileAddIcon" size="25" />
              {{ operationTitle }} Compte
            </h6>
          </b-col>

          <b-col cols="6">
            <b-button
              v-if="$router.name == 'analyticplan-view'"
              variant="outline-primary"
              class="btn-sm float-right"
              @click="
                $router.push({
                  name: 'analyticplan-view',
                  params: { id: analyticplanData.id + 1 },
                })
              "
            >
              <span class="d-none d-sm-inline">Suiv.</span>
              <feather-icon icon="ChevronRightIcon" size="12" />
            </b-button>
            <b-button
              v-if="$router.name == 'analyticplan-view'"
              variant="outline-primary"
              class="btn-sm float-right"
              @click="
                $router.push({
                  name: 'analyticplan-view',
                  params: { id: analyticplanData.id - 1 },
                })
              "
            >
              <feather-icon icon="ChevronLeftIcon" size="12" />
              <span class="d-none d-sm-inline">Préc.</span>
            </b-button>

            <b-button
              variant="outline-primary"
              class="btn-sm float-right"
              @click="
                $router.push({
                  name: 'analyticplan-list',
                })
              "
            >
              <feather-icon icon="ListIcon" size="12" />
              <span class="d-none d-sm-inline">Liste des Comptes</span>
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <!-- account_number -->
          <b-col cols="6" md="3">
            <validation-provider
              #default="validationContext"
              name="account_number"
              rules="required"
            >
              <b-form-group :state="getValidationState(validationContext)">
                <label label-for="account_number">
                  N°
                  <small class="text-warning">*</small>
                </label>
                <b-form-input
                  id="account_number"
                  v-model="analyticplanData.account_number"
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Ex: 1042"
                  size="sm"
                />
                <b-form-invalid-feedback>
                  Saisissez numero de compte svp.
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- account_name -->
          <b-col cols="6" md="6">
            <validation-provider
              #default="validationContext"
              name="account_name"
              rules="required"
            >
              <b-form-group :state="getValidationState(validationContext)">
                <label label-for="account_name">
                  Intitulé du compte
                  <small class="text-warning">*</small>
                </label>
                <b-form-input
                  id="account_name"
                  v-model="analyticplanData.account_name"
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Ex: Opérations courantes"
                  size="sm"
                />
                <b-form-invalid-feedback>
                  Saisissez intitulé de compte svp.
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" md="3">
            <!-- account_nature -->
            <validation-provider
              #default="validationContext"
              name="account_nature"
              rules="required"
            >
              <b-form-group
                label-for="account_nature"
                :state="getValidationState(validationContext)"
              >
                <label label-for="account_nature">
                  Nature de compte
                  <small class="text-warning">*</small>
                </label>
                <v-select
                  v-model="analyticplanData.account_nature"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="accountNatureOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                  input-id="account_nature"
                  size="sm"
                  class="select-size-sm"
                />
                <b-form-invalid-feedback
                  :state="getValidationState(validationContext)"
                >
                  Sélectionner nature de compte svp.
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- report_next -->
          <b-col cols="6" md="6">
            <validation-provider
              #default="validationContext"
              name="report_next"
              rules="required"
            >
              <b-form-group
                label="Report à nouveau"
                label-for="report_next"
                :state="getValidationState(validationContext)"
              >
                <b-form-radio-group
                  id="report_next"
                  v-model="analyticplanData.report_next"
                  :options="reportNextOptions"
                  value="Aucun"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <hr class="invoice-spacing" />

        <app-collapse
          accordion
          :type="collapseType"
          ref="app-collapse-item"
          style="padding-left: 0px; padding-top: 0px; border: 1px solid silver"
        >
          <app-collapse-item
            id="collapse_item_1"
            title="Analytique / Liste des projets (Facultatif)"
          >
            <b-row
              v-for="(
                analyticPlan, analyticPlan_index
              ) in analyticplanData.analytic_plan"
              :id="analyticPlan_index"
              :key="analyticPlan_index"
              ref="row" 
            >
              <!-- account_number -->
              <b-col cols="6" md="3">
                <validation-provider
                  #default="validationContext"
                  name="account_number"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="account_number">
                      N° Compte Analytique
                      <small class="text-warning">*</small>
                    </label>
                    <b-form-input
                      :id="
                        `analyticplanData.analytic_plan.` +
                        analyticPlan_index +
                        `.account_number`
                      "
                      v-model="
                        analyticplanData.analytic_plan[analyticPlan_index]
                          .account_number
                      "
                      :state="getValidationState(validationContext)"
                      trim
                      placeholder="Ex: 1042"
                      size="sm"
                    />
                    <b-form-invalid-feedback>
                      Saisissez numero de compte [Analytique] svp.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- account_name -->
              <b-col cols="6" md="3">
                <validation-provider
                  #default="validationContext"
                  name="account_name"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="account_name">
                      Intitulé du compte
                      <small class="text-warning">*</small>
                    </label>
                    <b-form-input
                      :id="
                        `analyticplanData.analytic_plan.` +
                        analyticPlan_index +
                        `.account_name`
                      "
                      v-model="
                        analyticplanData.analytic_plan[analyticPlan_index]
                          .account_name
                      "
                      :state="getValidationState(validationContext)"
                      trim
                      placeholder="Ex: Opérations courantes"
                      size="sm"
                    />
                    <b-form-invalid-feedback>
                      Saisissez intitulé de compte svp.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="6" md="3">
                <!-- amount_operation -->
                <validation-provider
                  #default="validationContext"
                  name="amount_operation"
                  rules="required"
                >
                  <b-form-group
                    label-for="amount_operation"
                    :state="getValidationState(validationContext)"
                  >
                    <label label-for="amount_operation">
                      Opération sur Montant
                      <small class="text-warning">*</small>
                    </label>
                    <v-select
                      :id="
                        `analyticplanData.analytic_plan.` +
                        analyticPlan_index +
                        `.amount_operation`
                      "
                      v-model="
                        analyticplanData.analytic_plan[analyticPlan_index]
                          .amount_operation
                      "
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="amountOperationOption"
                      :reduce="(val) => val.value"
                      :clearable="false"
                      size="sm"
                      class="select-size-sm"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      Sélectionner opération sur montant svp.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- amount -->
              <b-col cols="6" md="3">
                <validation-provider
                  #default="validationContext"
                  name="amount"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <label label-for="amount">
                      Montant
                      <small class="text-warning">*</small>
                    </label>
                    <b-form-input
                      :id="
                        `analyticplanData.analytic_plan.` +
                        analyticPlan_index +
                        `.amount`
                      "
                      v-model="
                        analyticplanData.analytic_plan[analyticPlan_index]
                          .amount
                      "
                      :state="getValidationState(validationContext)"
                      trim
                      placeholder="Ex: 10000"
                      size="sm"
                    />
                    <b-form-invalid-feedback>
                      Saisissez montant svp.
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <hr class="invoice-spacing" />

            </b-row>
          </app-collapse-item>
        </app-collapse>

        <hr class="invoice-spacing" />

        <b-row style="margin-bottom: 20px" v-if="showed == true">
          <b-col cols="12">
            <b-button
              ref="refSubmitEl"
              type="submit"
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            >
              <feather-icon icon="SaveIcon" v-if="loading == false" size="19" />

              {{ actionName }}
            </b-button>
            <b-button
              variant="outline-secondary"
              type="reset"
              @click="reinitForm"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            >
              Annuler
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <b-row style="margin-bottom: 20px" v-if="analyticplanData == null">
      <b-col cols="12">
        <h1>Chargement des données en cours...</h1>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import { ref, onUnmounted } from "@vue/composition-api";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import store from "@/store";
import { required, integer } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
// analyticplans
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
// accordions
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

import {
  BMedia,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BFormRadioGroup,
  BPopover,
  VBToggle,
  BAvatar,
  BFormFile,
  BMediaAside,
  BTable,
  BCardHeader,
  BCardTitle,
  // Form Validation
  BFormInvalidFeedback,
  BFormDatepicker,
  BMediaBody,
  BImg,
} from "bootstrap-vue";

// alerts

import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import invoiceStoreModule from "./storeModule";
import router from "@/router";

const moduleName = "analyticplan";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormRadioGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    BFormDatepicker,
    Logo,
    BMedia,
    BMediaBody,
    BFormFile,
    BMediaAside,
    BImg,
    BAvatar,
    BTable,
    BCardHeader,
    BCardTitle,
    AppCollapse,
    AppCollapseItem,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
  },
  data() {
    return {
      operationTitle: "",
      operationIcon: "",
      actionName: "",
      actionIndex: 0,
      showed: true,
      loading: false,
      collapseType: "default",
      analyticPlanOptions: [],
    };
  },
  props: {
    analyticplanData: {
      type: Object,
    },
    defaultanalyticplanData: {
      type: Object,
    },
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  mixins: [heightTransition],
  async mounted() {
    if (router.currentRoute.name == moduleName + "-add-new") {
      var now = new Date();
      this.sku_analyticplan = "ag-" + now.getTime();

      this.operationTitle = "Nouveau ";
      this.imageActionText = "Ajouter ";
      this.operationIcon = "AddIcon";

      this.actionName = "Enregistrer ";
      this.imageActionText = "Ajouter";
      this.actionIndex = 1;
      this.showed = true;
    }
    if (router.currentRoute.name == moduleName + "-view") {
      this.sku_analyticplan = router.currentRoute.params.id;
      this.operationTitle = "Détails du ";
      this.imageActionText = "?";
      this.operationIcon = "EyeIcon";

      this.actionName = "Visionner";
      this.imageActionText = "?";
      this.actionIndex = 2;
      this.showed = false;
    }

    if (router.currentRoute.name == moduleName + "-edit") {
      this.sku_analyticplan = router.currentRoute.params.id;
      this.operationTitle = "Modification du ";
      this.operationIcon = "EditIcon";
      this.imageActionText = "Modifier";

      this.actionName = "Enregistrer Modifications";
      this.imageActionText = "Modifier";
      this.actionIndex = 3;
      this.showed = true;
    }

    // empty array
    this.analyticplanData.analytic_plan = [];

    this.analyticplanData.analytic_plan.push(
      { account_name: "DFJ Projet OXfam", account_number: "1025" },
      { account_name: "Projet Onnu Femme", account_number: "1026" }
    );

    // load projects list
    await myApi
      .get(`analyticplan`)
      .then((response) => {
        var data = response.data.data;
        var i = 0;
        for (i = 0; i < data.length; i++) {
          this.analyticPlanOptions.push({
            label: data[i].name,
            value: data[i].account_number,
          });
        }
      })
      .catch((error) => {
        //
        console.log(error);
      });
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    addNewAnalyticPlanAccount() {
      this.analyticplanData.analytic_plan.push({
        accounting_plan: "",
        account_number: "",
        account_name: "",
        account_type: "",
        ammount: "",
        ammount_operation: "",
      });
      /* this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      }); */
    },
    addNewAnalyticPlanAccountOutput() {
      this.analyticplanData.analytic_plan.push({
        accounting_plan: "",
        account_number: "",
        account_name: "",
        account_type: "",
        ammount: "",
        ammount_operation: "",
      });
      /* this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      }); */
    },
    removeAnalyticPlanAccount(index) {
      this.analyticplanData.analytic_plan.splice(index, 1);
      /* this.trTrimHeight(this.$refs.row[0].offsetHeight); */
    },
    reinitForm() {
      this.$props.analyticplanData = this.defaultanalyticplanData;

      if (router.currentRoute.name == "analyticplan-add-new") {
        // init empty analyticplan data
        // analyticplanData = this.defaultanalyticplanData;
      } else {
        // requirement //
        // store
        //   .dispatch(APP_STORE_MODULE_NAME + "/fetchModule", {
        //     id: router.currentRoute.params.id,
        //   })
        //   .then((response) => {
        //     analyticplanData.value = response.data;
        //   })
        //   .catch((error) => {
        //     if (error.response.status === 404) {
        //       analyticplanData.value = undefined;
        //     }
        //   });
      }
      // remove all occurences
      // initialise 1 element
      // this.$props.analyticplanData.steps.push(
      //   JSON.parse(JSON.stringify(this.$props.stepformblankData))
      // );
    },
    async addUpdateItemAction() {
      // ----------------------------------------------------
      let formData = new FormData();
      const defaultActionText = this.actionName;

      let method = "";
      let params = "";

      if (router.currentRoute.name == "analyticplan-add-new") {
        this.actionName = "Enregistrement...";
        method = "post";
      }
      if (router.currentRoute.name == "analyticplan-view") {
        method = "get";
        params = "/" + this.analyticplanData.id;
      }
      if (router.currentRoute.name == "analyticplan-edit") {
        this.actionName = "Modification...";
        method = "put";
        params = "/" + this.analyticplanData.id;
      }

      // finalise form data
      formData = this.$props.analyticplanData;

      await myApi({
        url: "analyticplan" + params,
        method: method,
        data: formData,
      })
        .then((response) => {
          // default action
          this.actionName = defaultActionText;
          if (response.status == 200) {
            this.$swal({
              title: "Fin de l'opération",
              text: response.data.message,
              icon: "success",
              timer: 5000,
              showCancelButton: true,
              confirmButtonText: "Afficher Formulaire Vide",
              cancelButtonText: "Afficher Liste ?",
              customClass: {
                confirmButton: "btn btn-success",
                cancelButton: "btn btn-outline-primary ml-1",
              },
              buttonsStyling: false,
            }).then((result) => {
              if (result.value) {
                // stay here
                // reinit form
                this.reinitForm();
              } else if (result.dismiss === "cancel") {
                // redirection to list
                router.push({ name: "analyticplan-list" });
              }
            });
          } else {
            this.actionName = defaultActionText;
            this.errors.push(response.data.message);
            this.showToast(
              "Erreur Survenu",
              response.data.message,
              "warning",
              "CheckIcon",
              "top-center",
              4000
            );
          }
        })
        .catch((error) => {
          //
          this.actionName = defaultActionText;

          this.showToast(
            "Erreur Exceptionnelle Survenu",
            error.response.data.message,
            "warning",
            "CheckIcon",
            "top-center",
            5000
          );
        });
    },
    goToPrecItem() {
      router.push({ name: "analyticplan-view" });
    },
    goToNextItem() {
      router.push({ name: "analyticplan-list" });
    },
    goToList() {
      router.push({ name: "analyticplan-list" });
    },
    // alert
    alertAutoClose(header, message, seconds, cssClass) {
      this.$swal({
        title: header,
        html: message,
        timer: seconds,
        customClass: {
          confirmButton: cssClass,
        },
        buttonsStyling: false,
      });
      // "btn btn-primary",
    },
    // analyticplan
    showToast(header, message, variant, icon, position, timeout) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: header,
            icon,
            text: message,
            variant,
          },
        },
        {
          position,
          timeout,
        }
      );
    },
  },
  setup() {
    //////////////////////////////////////////////////////////////////////////
    const INVOICE_APP_STORE_MODULE_NAME = "app-analyticplan";

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME))
      store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME))
        store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME);
    });

    let resetanalyticplanData = () => {
      // this.analyticplanData = this.$props.analyticplanData;
    };

    let { refFormObserver, getValidationState, resetForm } = formValidation(
      resetanalyticplanData
    );

    const currencyOptions = [
      { label: "Dolars Etats-Unis", value: "USD" },
      { label: "Francs Congolais", value: "FC" },
      { label: "Francs CFA", value: "FCFA" },
      { label: "Shilling Uganda", value: "USH" },
      { label: "Francs Rwandais", value: "RW" },
      { label: "Dirhams Emiratis", value: "AED" },
    ];

    const reportNextOptions = [
      { text: "Aucun", value: "aucun" },
      { text: "Avec Solde", value: "solde" },
      { text: "Détails", value: "détail" },
    ];

    const amountOperationOption = [
      { label: "Montant", value: "Montant" },
      { label: "Pourcentage", value: "Pourcentage" },
      { label: "Equilibre", value: "Equilibre" },
    ];

    const accountNatureOptions = [
      { label: "--Afficher Tout--", value: "" },
      { label: "Charge", value: "Charge" },
      { label: "Capitaux", value: "Capitaux" },
      { label: "Amortis./Provision", value: "Amortis./Provision" },
      { label: "Aucune", value: "Aucune" },
      { label: "Résultat-Bilan", value: "Résultat-Bilan" },
      { label: "Résultat-Gestion", value: "Résultat-Gestion" },
      { label: "Stock", value: "Stock" },
      { label: "Produit", value: "Produit" },
      { label: "Immobilisation", value: "Immobilisation" },
      { label: "Fournisseur", value: "Fournisseur" },
      { label: "Client", value: "Client" },
      { label: "Salarié", value: "Salarié" },
      { label: "Titre", value: "Titre" },
      { label: "Banque", value: "Banque" },
      { label: "Caisse", value: "Caisse" },
    ];

    return {
      refFormObserver,
      getValidationState,
      currencyOptions,
      resetForm,
      accountNatureOptions,
      amountOperationOption,
      reportNextOptions,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.card .card-header {
  border-bottom: none;
  padding: 0px;
  background: orange;
  text-color: white;
  font-color: white;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/quill.scss";
</style>
